var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"carousel-product-card"},[_c('ProductCard',{staticClass:"carousel-product-card__inner",attrs:{"item":_vm.item,"sliderIsClickble":_vm.sliderIsClickble,"tag":_vm.tag}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }